// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx","901":"component---src-pages-cool-stuff-index-tsx"}[chunkId] + "-" + {"218":"8df68170fd62fe502c13","351":"2ea021cb152af4d00bb1","691":"90b52666807c18094fd2","901":"aadec420f891a4660527"}[chunkId] + ".js";
};